export default function ProductSchema(props: any) {
  if (props && props.schemaType && props.schemaType === "online") {
    const {
      fields: { title, url, metadata, listingImage },
    } = props.primary;

    const { fields: image } = listingImage;

    const data = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: title,
      image: [`https:${image.file.url}`],
      description: metadata.fields.description,
      brand: {
        "@type": "Brand",
        name: "Cosmetic College",
      },
      offers: {
        "@type": "Offer",
        url: `https://cosmetic.college${url}`,
        priceCurrency: "GBP",
        price: props.amount / 100,
        itemCondition: "https://schema.org/NewCondition",
        availability: "https://schema.org/InStock",
      },
    };
    console.log("online schema", data);
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(data),
        }}
      />
    );
  }

  if (
    !props ||
    !props.schemaType ||
    (props.schemaType && props.schemaType !== "product")
  ) {
    return null;
  }
  const {
    fields: { title, url, metadata, listingImage },
  } = props;

  const { fields: image } = listingImage;

  const data = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: title,
    image: [`https:${image.file.url}`],
    description: metadata.fields.description,
    brand: {
      "@type": "Brand",
      name: "Cosmetic College",
    },
    offers: {
      "@type": "Offer",
      url: `https://cosmetic.college${url}`,
      priceCurrency: "GBP",
      price:
        props.events && props.events.length > 0
          ? props.events[0].seat_price / 100
          : props.standardPrice / 100,
      itemCondition: "https://schema.org/NewCondition",
      availability: "https://schema.org/InStock",
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data),
      }}
    />
  );
}
